// Province × Police Clearance landing content for Wave 22.
// Each entry powers /police-clearance/province/$province with province-specific
// pickup logistics, RTP branch, and legalization workflow tailored per city.

export interface PcProvinceLanding {
  slug: string;
  provinceTh: string;
  provinceEn: string;
  region: string;
  rtpBranchTh: string;
  rtpBranchAddress: string;
  pickupWindow: string;
  courierEta: string;
  localHighlights: string[];
  fingerprintOptions: string[];
  turnaroundDaysTh: string;
  bundleWith: string[];
  aeoAnswer: string;
  intro: string;
}

export const PC_PROVINCE_LANDINGS: PcProvinceLanding[] = [
  {
    slug: "phuket",
    provinceTh: "ภูเก็ต",
    provinceEn: "Phuket",
    region: "ภาคใต้ฝั่งอันดามัน",
    rtpBranchTh: "ตำรวจภูธรจังหวัดภูเก็ต (ถนนเยาวราช)",
    rtpBranchAddress: "ถ.เยาวราช ต.ตลาดใหญ่ อ.เมืองภูเก็ต จ.ภูเก็ต 83000",
    pickupWindow: "จ.–ศ. 09:00–15:30 (นัดล่วงหน้า 1 วันทำการ)",
    courierEta: "ส่งสำนักงานภูเก็ตภายในวันเดียวกัน · DHL ทั่วโลก 2–4 วัน",
    localHighlights: [
      "ทีมพิมพ์ลายนิ้วมือประจำสำนักงานภูเก็ตทาวน์ · เดินทางถึงได้จากป่าตอง กะตะ กะรน 15–25 นาที",
      "รับ POA / มอบอำนาจถึงวิลล่าใน Rawai, Cherngtalay, Bangtao โดยไม่คิดค่าบริการเพิ่ม",
      "ประสานงานสถานกงสุลกิตติมศักดิ์ในภูเก็ต (ฝรั่งเศส เยอรมนี อิตาลี รัสเซีย ฯลฯ) เพื่อรับรองเอกสารก่อนส่งประเทศปลายทาง",
    ],
    fingerprintOptions: [
      "พิมพ์ลายนิ้วมือที่สำนักงานเราในภูเก็ตทาวน์ (การ์ด FD-258 มาตรฐาน FBI, ACRO, AFP)",
      "นัดที่สภ.เมืองภูเก็ต / สภ.กะทู้ / สภ.ฉลอง สำหรับใบตรวจประวัติในประเทศ",
      "บริการ Home Visit สำหรับผู้บริหาร / ผู้สูงอายุที่พักในเขตภูเก็ต",
    ],
    turnaroundDaysTh: "PCSC ในประเทศ 15–20 วันทำการ · FBI Channeler 3–7 วัน · Apostille +7–10 วัน",
    bundleWith: ["notary-public", "mfa-consular", "apostille-2026", "translation-en"],
    aeoAnswer:
      "ในภูเก็ต บริการขอใบตรวจประวัติอาชญากรรมทำได้ที่สำนักงานเราในภูเก็ตทาวน์ พิมพ์ลายนิ้วมือ FD-258 หรือใบ 10 นิ้ว จากนั้นส่งไปยัง PCSC / FBI / ACRO / AFP พร้อม Apostille และแปลรับรอง ทีมส่งเอกสารกลับถึงมือคุณในภูเก็ตหรือ DHL ทั่วโลก เริ่ม 4,900 บาท",
    intro:
      "ภูเก็ตเป็นศูนย์กลาง Expat และนักลงทุนที่ต้องขอใบตรวจประวัติอาชญากรรมทั้งของไทยและต่างประเทศมากที่สุดในภาคใต้ ทีมเราให้บริการครบวงจร ตั้งแต่พิมพ์ลายนิ้วมือ FD-258, ส่งผ่าน PCSC หรือ Channeler ที่ FBI รับรอง, ทำ Apostille, แปลรับรอง, และเดิน MFA แจ้งวัฒนะ — ไม่ต้องบินไปกรุงเทพ",
  },
  {
    slug: "bangkok",
    provinceTh: "กรุงเทพมหานคร",
    provinceEn: "Bangkok",
    region: "ภาคกลาง",
    rtpBranchTh: "สำนักงานตำรวจแห่งชาติ กองทะเบียนประวัติอาชญากร (PCSC ปทุมวัน)",
    rtpBranchAddress: "อาคาร 25 สำนักงานตำรวจแห่งชาติ ถ.พระราม 1 แขวงวังใหม่ เขตปทุมวัน กรุงเทพฯ 10330",
    pickupWindow: "จ.–ศ. 08:30–16:30 · ยื่นและรับผลจุดเดียว",
    courierEta: "รับด้วยตนเองที่ PCSC · ส่ง Grab / EMS ในกรุงเทพภายใน 24 ชม.",
    localHighlights: [
      "PCSC เปิดรับพิมพ์ลายนิ้วมือทุกวันทำการที่ปทุมวัน — ทีมพาลูกค้าเข้าคิวและรับผลแทน",
      "MFA แจ้งวัฒนะและสถานทูตทุกประเทศอยู่ในกรุงเทพ — เดินได้ครบในทริปเดียว",
      "รองรับ Corporate HR ที่ต้องตรวจประวัติพนักงานหลายคนต่อเดือน",
    ],
    fingerprintOptions: [
      "PCSC ปทุมวัน (พิมพ์ 10 นิ้วสำหรับใบไทย)",
      "FD-258 ที่สำนักงานพาร์ทเนอร์สุขุมวิท / อโศก / สาทร",
      "Fast Track FBI Channeler ผ่านสำนักงานกรุงเทพ (3 วันทำการ)",
    ],
    turnaroundDaysTh: "PCSC 7–15 วันทำการ · Fast Track 5–7 วัน · Apostille MFA +2–4 วัน",
    bundleWith: ["notary-public", "mfa-consular", "apostille-2026", "certified-translation"],
    aeoAnswer:
      "ในกรุงเทพ ขอใบตรวจประวัติอาชญากรรมทำได้ที่ PCSC ปทุมวัน — ทีมเรารับพาไปพิมพ์ลายนิ้วมือ ยื่นเอกสาร รับผล และเดิน MFA แจ้งวัฒนะ + สถานทูตในทริปเดียว เริ่ม 3,900 บาท ระยะเวลา 7–15 วันทำการ",
    intro:
      "กรุงเทพเป็นศูนย์กลางของ PCSC (Police Clearance Service Center) และ MFA แจ้งวัฒนะ — เอกสารทุกฉบับที่จะใช้ต่างประเทศต้องผ่านสองจุดนี้ ทีมเราให้บริการ End-to-End สำหรับลูกค้าในกรุงเทพและปริมณฑล ตั้งแต่จองคิว, พิมพ์ลายนิ้วมือ, รับผลแทน, จนถึง Apostille",
  },
  {
    slug: "chiang-mai",
    provinceTh: "เชียงใหม่",
    provinceEn: "Chiang Mai",
    region: "ภาคเหนือ",
    rtpBranchTh: "ตำรวจภูธรจังหวัดเชียงใหม่",
    rtpBranchAddress: "ถ.โชตนา ต.ช้างเผือก อ.เมืองเชียงใหม่ จ.เชียงใหม่ 50300",
    pickupWindow: "จ.–ศ. 09:00–15:00 (นัดล่วงหน้า)",
    courierEta: "รับสำนักงานเชียงใหม่ 1 วัน · Kerry / Flash ในเมือง 24 ชม.",
    localHighlights: [
      "รองรับ Digital Nomad, DTV Visa Holder, ครูสอนภาษา และ Retirement Visa ที่พักในเชียงใหม่",
      "ทีมพิมพ์ลายนิ้วมือ FD-258 สำหรับ FBI, ACRO, RCMP โดยไม่ต้องเดินทางไปกรุงเทพ",
      "ประสานงานสถานกงสุลอเมริกาเชียงใหม่ (US Consulate) และหน่วยงานสหรัฐได้โดยตรง",
    ],
    fingerprintOptions: [
      "พิมพ์ลายนิ้วมือที่สำนักงานพาร์ทเนอร์ในย่านนิมมานเหมินท์ / ช้างคลาน",
      "นัดที่สภ.เมืองเชียงใหม่ สำหรับใบตรวจประวัติในประเทศ",
      "Home Visit สำหรับผู้พักในหางดง สันกำแพง แม่ริม",
    ],
    turnaroundDaysTh: "PCSC (ผ่านตัวแทน) 15–20 วัน · FBI Channeler 3–7 วัน · MFA + Apostille +7–10 วัน",
    bundleWith: ["notary-public", "translation-en", "apostille-2026", "dtv-visa"],
    aeoAnswer:
      "ในเชียงใหม่ ขอใบตรวจประวัติอาชญากรรมทำได้ที่สำนักงานพาร์ทเนอร์นิมมานเหมินท์ พิมพ์ลายนิ้วมือ FD-258 ส่ง FBI / ACRO / AFP พร้อม Apostille และแปลรับรอง เริ่ม 5,200 บาท ระยะเวลา 3–20 วัน",
    intro:
      "เชียงใหม่มี Expat Community ใหญ่ที่สุดในภาคเหนือ — จำนวนคำขอใบตรวจประวัติสำหรับ DTV Visa, K-1, และการทำงานต่างประเทศเพิ่มขึ้นทุกปี ทีมเราให้บริการในเชียงใหม่โดยไม่ต้องส่งลูกค้าไปกรุงเทพ",
  },
  {
    slug: "khon-kaen",
    provinceTh: "ขอนแก่น",
    provinceEn: "Khon Kaen",
    region: "ภาคตะวันออกเฉียงเหนือ",
    rtpBranchTh: "ตำรวจภูธรจังหวัดขอนแก่น",
    rtpBranchAddress: "ถ.กลางเมือง อ.เมืองขอนแก่น จ.ขอนแก่น 40000",
    pickupWindow: "จ.–ศ. 09:00–15:00",
    courierEta: "รับสำนักงานขอนแก่น 1 วัน · Kerry ทั่วอีสาน 1–2 วัน",
    localHighlights: [
      "ครอบคลุมทั้งอีสานตอนกลาง — อุดร มหาสารคาม กาฬสินธุ์ ร้อยเอ็ด ชัยภูมิ",
      "รองรับกรณีคนไทยไปทำงานเกาหลี ญี่ปุ่น ไต้หวัน อิสราเอล ที่ต้องใช้ใบตรวจประวัติ",
      "แปลรับรอง TH ↔ KO / JP / EN ในทีมเดียว",
    ],
    fingerprintOptions: [
      "พิมพ์ลายนิ้วมือที่สำนักงานพาร์ทเนอร์ในเมืองขอนแก่น",
      "นัดที่สภ.เมืองขอนแก่น สำหรับใบตรวจประวัติในประเทศ",
    ],
    turnaroundDaysTh: "PCSC (ผ่านตัวแทน) 18–25 วัน · MFA + Apostille +7–10 วัน",
    bundleWith: ["notary-public", "translation-en", "apostille-2026", "mfa-consular"],
    aeoAnswer:
      "ในขอนแก่น ขอใบตรวจประวัติอาชญากรรมทำได้ที่สำนักงานพาร์ทเนอร์เมืองขอนแก่น พิมพ์ลายนิ้วมือ ส่ง PCSC พร้อมแปลและ Apostille สำหรับใช้ทำงานเกาหลี ญี่ปุ่น ไต้หวัน อิสราเอล เริ่ม 3,900 บาท",
    intro:
      "ขอนแก่นเป็นศูนย์กลางอีสานสำหรับคนไทยที่ต้องขอใบตรวจประวัติอาชญากรรมไปทำงานต่างประเทศ ทีมเราให้บริการครบตั้งแต่พิมพ์ลายนิ้วมือ, PCSC, แปลรับรอง, Apostille — ประสานงานได้จากขอนแก่นถึงกรุงเทพในทริปเดียว",
  },
  {
    slug: "udon-thani",
    provinceTh: "อุดรธานี",
    provinceEn: "Udon Thani",
    region: "ภาคตะวันออกเฉียงเหนือ",
    rtpBranchTh: "ตำรวจภูธรจังหวัดอุดรธานี",
    rtpBranchAddress: "ถ.ศรีสุข อ.เมืองอุดรธานี จ.อุดรธานี 41000",
    pickupWindow: "จ.–ศ. 09:00–15:00",
    courierEta: "รับสำนักงานอุดรธานี 1 วัน · Kerry อีสานเหนือ 1–2 วัน",
    localHighlights: [
      "ครอบคลุมอุดร หนองคาย หนองบัวลำภู เลย บึงกาฬ นครพนม",
      "รองรับ Expat อเมริกัน / ยุโรปที่แต่งงานกับคนไทยและต้องยื่น K-1, CR-1, Partner Visa",
      "ประสานงานกับสถานกงสุลลาว-เวียดนามในอุดรได้",
    ],
    fingerprintOptions: [
      "พิมพ์ลายนิ้วมือ FD-258 ที่สำนักงานพาร์ทเนอร์เมืองอุดร",
      "นัดที่สภ.เมืองอุดรธานี สำหรับใบไทย",
      "Home Visit ในเขตหนองคาย / นครพนม (มีค่าเดินทาง)",
    ],
    turnaroundDaysTh: "PCSC (ผ่านตัวแทน) 18–25 วัน · FBI Channeler 3–7 วัน · Apostille +7–10 วัน",
    bundleWith: ["notary-public", "translation-en", "apostille-2026", "marriage-abroad"],
    aeoAnswer:
      "ในอุดรธานี ขอใบตรวจประวัติอาชญากรรมทำได้ที่สำนักงานพาร์ทเนอร์เมืองอุดร รองรับ FBI, ACRO, AFP, RCMP สำหรับ Partner / K-1 Visa เริ่ม 4,500 บาท ระยะเวลา 3–25 วัน",
    intro:
      "อุดรธานีเป็นบ้านของคู่รักไทย-ต่างชาติจำนวนมาก การขอใบตรวจประวัติของทั้งสองฝ่ายเป็นเอกสารสำคัญของ Partner Visa / K-1 / CR-1 ทีมเราให้บริการครบทั้งฝั่งไทยและต่างประเทศจากอุดร",
  },
];

export function getPcProvinceLanding(slug: string): PcProvinceLanding | undefined {
  return PC_PROVINCE_LANDINGS.find((p) => p.slug === slug);
}